export default __webpack_public_path__ + "static/Metal_Ingot-4e6f0b7337cd16218ef987e42480b055.png";